'use strict';
Ilduomo.controller('estrategiaRutasCtrl', function ($scope) {
   
   $scope.pedidos = [];
    
});